import { useParams, Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';

const cardColors = [
  'bg-[#f5e6e0]',
  'bg-[#dce8e0]',
  'bg-[#e8e4e0]',
  'bg-[#e8dcc8]',
];

export default function CategoryGrid() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);
  const allArticles = categoryArticles.length > 0 ? categoryArticles : articles.slice(0, 8);

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-start justify-between mb-12">
          <div>
            <p className="font-heading text-xs tracking-widest uppercase text-foreground-400 mb-2">
              {category?.name || '全部'} · 文章
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              全部<span className="italic font-normal text-accent-500">内容</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {allArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-2xl overflow-hidden transition-transform duration-300 hover:-translate-y-1 cursor-pointer flex flex-col"
            >
              <div className={`${cardColors[index % 4]} aspect-[4/3] overflow-hidden`}>
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="bg-background-50 p-5 flex flex-col gap-2">
                <span className="text-xs text-accent-500 font-medium">
                  {article.category}
                </span>
                <h3 className="text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-accent-500 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.views.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}